'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactDropzone = require('react-dropzone');var _reactDropzone2 = _interopRequireDefault(_reactDropzone);
var _axios = require('axios');var _axios2 = _interopRequireDefault(_axios);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _uniqueId = require('lodash/uniqueId');var _uniqueId2 = _interopRequireDefault(_uniqueId);
var _isEqual = require('lodash/isEqual');var _isEqual2 = _interopRequireDefault(_isEqual);
var _findIndex = require('lodash/findIndex');var _findIndex2 = _interopRequireDefault(_findIndex);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _sha = require('sha1');var _sha2 = _interopRequireDefault(_sha);

var _PreviewList = require('./Preview/PreviewList');var _PreviewList2 = _interopRequireDefault(_PreviewList);
var _PreviewSingleImage = require('./Preview/PreviewSingleImage');var _PreviewSingleImage2 = _interopRequireDefault(_PreviewSingleImage);
var _CropperModal = require('../Cropper/CropperModal');var _CropperModal2 = _interopRequireDefault(_CropperModal);

var _constants = require('../../constants');










var _checkUserAgent = require('../../utils/checkUserAgent');var _checkUserAgent2 = _interopRequireDefault(_checkUserAgent);
var _helpers = require('./helpers');

var _UploadAssetWidget = require('./UploadAssetWidget.scss');var styles = _interopRequireWildcard(_UploadAssetWidget);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Helpers
// Styles
var videoSources = { internal: 'internal' };var formatContentFromResponse = function formatContentFromResponse(_ref, _ref2) {var data = _ref.data;var _id = _ref2._id,_ref2$angle = _ref2.angle,angle = _ref2$angle === undefined ? '0' : _ref2$angle,_ref2$relativeAngle = _ref2.relativeAngle,relativeAngle = _ref2$relativeAngle === undefined ? '0' : _ref2$relativeAngle,contentType = _ref2.contentType,type = _ref2.type;
  var baseUrl = (0, _constants.getAssetsBaseUrl)(contentType);
  var isVideo = contentType === _constants.cloudinaryContentTypes.VIDEO;
  var thumbnailExtension = isVideo ? '.jpg' : '';
  var source = isVideo && videoSources.internal;

  return {
    thumbnail: baseUrl + '/' + _constants.thumbnailModifier + '/' + data.public_id + thumbnailExtension,
    full: baseUrl + '/' + _constants.fullModifier + '/' + data.public_id,
    public_id: data.public_id,
    link: data.public_id,
    id: data.public_id,
    indexIdentifier: data.indexIdentifier,
    uploadInProgress: false,
    angle: angle,
    relativeAngle: relativeAngle,
    contentType: contentType,
    _id: _id,
    source: source,
    type: type,
    name: data.name };

};var

UploadAssetWidget = function (_Component) {_inherits(UploadAssetWidget, _Component);function UploadAssetWidget() {var _temp, _this, _ret;_classCallCheck(this, UploadAssetWidget);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.






























































    state = {
      images: _this.props.initialImages || [],
      videos: _this.props.initialVideos || [],
      imagesDeletedDuringUpload: [],
      uploadInProgress: false,
      isTabletDevice: _checkUserAgent2.default.isMobileOrTablet(navigator.userAgent),
      isOpenModalCropper: false,
      imgCropp: null,
      isCroppImg: null,
      contentLimit: {
        images: _this.props.limitImages || 25,
        videos: 1 } }, _this.



    componentDidMount = function () {
      _this.widget.addEventListener('click', _this.handleClick, true);
      window.addEventListener('dragover', _this.handleDrag);
      window.addEventListener('mouseover', _this.handleMouseOver);
      _this.widget.addEventListener('selectstart', _this.handleSelect);
    }, _this.











    componentWillUnmount = function () {
      _this.widget.removeEventListener('click', _this.handleClick, true);
      window.removeEventListener('dragover', _this.handleDrag);
      window.removeEventListener('mouseover', _this.handleMouseOver);
      _this.widget.removeEventListener('selectstart', _this.handleSelect);
    }, _this.

    onContentDrop = function (files) {
      if (_this.props.multiple) {
        var formattedFiles = files.map(_this.formatContentBeforeUpload);
        var sortedFiles = _this.sortFiles(formattedFiles);

        _this.setState(
        {
          images: [].concat(_this.state.images, sortedFiles.images),
          videos: [].concat(_this.state.videos, sortedFiles.videos) },

        function () {return _this.uploadContent([].concat(sortedFiles.images, sortedFiles.videos));});

      } else {
        var formatted = _this.formatContentBeforeUpload(files[0]);

        formatted && _this.setState({
          nameImage: formatted.name,
          images: [formatted] },
        function () {return _this.uploadContent([formatted]);});
      }
    }, _this.

    getStateKey = function (file) {var
      contentType = file.contentType;
      var type = contentType || file.type && file.type.split('/')[0];

      var isVideo = type === _constants.cloudinaryContentTypes.VIDEO;
      return isVideo ? 'videos' : 'images';
    }, _this.

    getPublicId = function (image) {return (
        image && image.public_id ?
        image.public_id :
        image.full.split('/').pop());}, _this.


    formatContentBeforeUpload = function (file, isDirectUpload) {
      var type = file.type.split('/');
      file.contentType = type[0];
      file.uploadInProgress = true;
      file._id = (0, _uniqueId2.default)('upload_image_');
      if (file.contentType === 'video' && file.size > _helpers.MAX_VIDEO_SIZE) {
        _this.showLimitMessage('videoSizeMessage');
        return null;
      }
      if (!_this.props.multiple && file.contentType === 'image' && file.size > _helpers.MAX_IMAGE_SIZE) {
        _this.showLimitMessage('imageSizeMessage');
        return null;
      }
      if (isDirectUpload && file.contentType !== 'video' && file.size > _helpers.MAX_CHUNK_SIZE) {
        file.chunksData = (0, _helpers.splitFileToChunks)(file);
      }

      return file;
    }, _this.

    handleCropp = function (file) {
      var formated = _this.formatContentBeforeUpload(file);
      _this.setState({ images: [file] });

      _this.closeModalCropper();
      _this.croppImg(true);
      _this.sendFile(formated);
    }, _this.

    showLimitMessage = function (errorKey) {return _this.props.openMessageModal({
        message:
        _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.limitMessage, 'successMessage') },
          _react2.default.createElement('p', null, _this.props.rootTranslate('uploadWidget', errorKey))),


        isCloseButtonInvisible: true });}, _this.


    sortFiles = function () {var files = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];return files.reduce(function (acc, item) {
        var stateKey = _this.getStateKey(item);

        if (_this.state[stateKey].length + acc[stateKey].length < _this.state.contentLimit[stateKey]) {
          if (item.contentType === 'video' && item.size > _helpers.MAX_VIDEO_SIZE) {
            _this.showLimitMessage('videoSizeMessage');
            return acc;
          }
          if (item.contentType !== 'video' && item.size > _helpers.MAX_CHUNK_SIZE) {
            _this.showLimitMessage('fileSizeMessage');
            return acc;
          }
          if (item.contentType === 'image' && item.size > _helpers.MAX_IMAGE_SIZE) {
            _this.showLimitMessage('imageSizeMessage');
            return acc;
          }
          acc[stateKey].push(item);
        } else {
          _this.showLimitMessage(_this.props.isRaw ? 'limitationRawError' : 'limitationError');
        }

        return acc;
      }, { images: [], videos: [] });}, _this.

    handleSelect = function (evt) {
      evt.preventDefault();
    }, _this.

    handleDrag = function (event) {
      event.preventDefault();
      event.dataTransfer.effectAllowed = 'none';
      event.dataTransfer.dropEffect = 'none';
      _this.widget.classList.add(styles.dropArea);
    }, _this.

    handleMouseOver = function () {
      if (_this.widget.classList.contains(styles.dropArea)) {
        _this.widget.classList.remove(styles.dropArea);
      }
    }, _this.

    sendFile = function (file) {
      if (file.chunksData && file.chunksData instanceof Array) {
        var id = (0, _uniqueId2.default)('upload');
        return Promise.all(file.chunksData.map(function (chunk) {return _this.cloudinaryUpload(file, chunk, id);}));
      }

      return _this.cloudinaryUpload(file);
    }, _this.

    cloudinaryUpload = function (file, chunk, uploadId) {var
      index = file.index,_id = file._id,contentType = file.contentType,size = file.size,name = file.name,type = file.type;var _ref3 =
      chunk || {},rangeHeaderValue = _ref3.rangeHeaderValue,chunkData = _ref3.chunkData;

      var timestamp = '';
      var signature = '';

      var uploadProgressBar = document.querySelector('#uploadProgressBar_' + _id);
      var urlType = type === 'application/pdf' ? 'raw' : contentType;

      var uploadUrl = _this.props.directUploadToCLoudinary ?
      (0, _constants.getCloudinaryActionUrl)(contentType, _constants.cloudinaryActions.UPLOAD) :
      (0, _constants.getAssetsActionUrl)(urlType);

      var urlAdditional = _this.props.suspendedUpload ? '/suspend' : '';

      var stateKey = _this.getStateKey(file);

      var directUploadHeaders = chunk ? {
        'X-Unique-Upload-Id': (0, _sha2.default)('size=' + size + _constants.CLOUDINARY_API_SECRET + uploadId),
        'Content-Range': rangeHeaderValue } :
      undefined;

      var headers = _this.props.directUploadToCLoudinary ?
      directUploadHeaders :
      {};

      var uploadData = new FormData();

      if (_this.props.directUploadToCLoudinary) {
        timestamp = Math.floor(Date.now() / 1000);
        signature = (0, _sha2.default)('timestamp=' + timestamp + _constants.CLOUDINARY_API_SECRET);
        uploadData.append('timestamp', timestamp);
        uploadData.append('signature', signature);
        uploadData.append('api_key', _constants.CLOUDINARY_API_KEY);
      }

      uploadData.append('file', chunk ? chunkData : file);

      return _axios2.default.post('' + uploadUrl + urlAdditional, uploadData, {
        headers: headers,
        timeout: 60000000,
        onUploadProgress: function onUploadProgress(progressEvent) {
          if (uploadProgressBar && uploadProgressBar.offsetParent) {
            if (!uploadProgressBar.offsetParent.style.border) {
              uploadProgressBar.offsetParent.style.border = 'solid 1px #cccccc';
            }
            uploadProgressBar.style.width = Math.round(progressEvent.loaded * 100.0 / progressEvent.total) + '%';
          }
        },
        transformResponse: function transformResponse(data) {
          var response = JSON.parse(data);
          response.indexIdentifier = 'image_' + index;
          response.name = name;
          return response;
        } }).

      then(function (response) {
        var isFileUploaded = (0, _get2.default)(response, 'data.done') !== false; // important, 'data.done' is not equal only 'false'
        var loadingError = (0, _get2.default)(response, 'data.error');

        if (!!loadingError) {
          _this.showLimitMessage('uploadErrorMessage');
          throw new Error(loadingError.message);
        }

        return isFileUploaded && _this.saveUploadedContentToState(file, response);
      }).
      catch(function (err) {return _this.timeoutUpload(err, _id, stateKey);});
    }, _this.

    cloudinaryDelete = function (publicId) {
      var timestamp = Math.floor(Date.now() / 1000);
      var signature = (0, _sha2.default)('public_id=' + publicId + '&timestamp=' + timestamp + _constants.CLOUDINARY_API_SECRET);
      var deleteUrl = (0, _constants.getCloudinaryActionUrl)(_constants.cloudinaryContentTypes.IMAGE, _constants.cloudinaryActions.DESTROY);
      return _axios2.default.post(deleteUrl,
      {
        timestamp: timestamp,
        public_id: publicId,
        api_key: _constants.CLOUDINARY_API_KEY,
        signature: signature });


    }, _this.

    timeoutUpload = function (err, contentId, stateKey) {var _this$setState;return _this.setState((_this$setState = {}, _this$setState[
      stateKey] = _this.state[stateKey].filter(function (_ref4) {var _id = _ref4._id;return _id !== contentId;}), _this$setState));}, _this.


    _uploadContent = function (files) {return Promise.all(files.map(function (file) {return (
          _this.sendFile(file));}));}, _this.


    uploadContent = function (files) {
      if (files.length) {
        _this.setState({ uploadInProgress: true });
        _this.props.uploadInProgress(true);

        _this._uploadContent(files).
        then(_this.uploadFinish);
      }
    }, _this.

    uploadFinish = function () {
      _this.setState({ uploadInProgress: false });
      _this.props.uploadInProgress(false);
    }, _this.

    saveUploadedContentToState = function (file, cloudinaryResponse) {var _this$setState2;
      var stateKey = _this.getStateKey(file);

      var data = [].concat(_this.state[stateKey]);
      var fileIndex = (0, _findIndex2.default)(data, function (item) {return item._id === file._id;});

      if (fileIndex === -1) {
        console.error('No image with this index');
        return;
      }

      var uploadedContent = formatContentFromResponse(cloudinaryResponse, data[fileIndex]);
      var updatedData = data.map(function (item) {return item._id === file._id ? uploadedContent : item;});

      !_this.state.isCroppImg && _this.setState({ imgCropp: updatedData[0].full, isOpenModalCropper: true });
      _this.setState((_this$setState2 = {}, _this$setState2[stateKey] = updatedData, _this$setState2), function () {
        _this.props.contentUploaded(updatedData, uploadedContent, stateKey);
      });
    }, _this.

    hideCropperModal = function (evt) {var _this$state$images =
      _this.state.images,image = _this$state$images[0];

      _this.deleteContent(evt, 0, image);
      _this.setState({ imgCropp: null, isOpenModalCropper: false });
    }, _this.

    markAssetToDelete = function (publicId) {var contentType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'image';
      _this.props.markAssetToDelete && _this.props.markAssetToDelete({ publicId: publicId, contentType: contentType });
    }, _this.

    deleteAllContent = function () {
      var imagesShouldBeDeletedPublicId = _this.state.images.map(function (image) {return (
          image.public_id ?
          image.public_id :
          image.full.split('/').pop());});

      var videosShouldBeDeletedPublicId = _this.state.videos.map(function (video) {return (
          video.public_id ?
          video.public_id :
          video.full.split('/').pop());});


      imagesShouldBeDeletedPublicId.forEach(function (id) {return _this.markAssetToDelete(id, 'image');});
      videosShouldBeDeletedPublicId.forEach(function (id) {return _this.markAssetToDelete(id, 'video');});

      _this.setState({
        images: [],
        videos: [] });

      _this.props.updateContent([], 'images');
      _this.props.updateContent([], 'videos');
      // Promise.all(imagesShouldBeDeletedPublicId.map(this.cloudinaryDelete)) // TODO Uncomment to delete from cloudinary
      //   .then(() => {
      //     imagesShouldBeDeletedPublicId = null;
      //   })
      //   .catch(error => console.error(error));
    }, _this.

    deleteContent = function (event, index, contentItem) {
      event && event.stopPropagation();
      var stateKey = _this.getStateKey(contentItem);

      var publicId = contentItem.full ? _this.getPublicId(contentItem) : '';

      _this.markAssetToDelete(publicId, contentItem.contentType);

      _this.deleteContentFromCloudinaryAndFromState(publicId, index, stateKey);
      _this.setState({ uploadInProgress: false });
      _this.croppImg(false);
    }, _this.

    deleteContentFromCloudinaryAndFromState = function (publicId, index, stateKey) {
      if (_this.state[stateKey].length) {
        // this.cloudinaryDelete(publicId); // TODO Uncomment to delete from cloudinary
        _this.deleteContentFromStateByIndex(index, stateKey);
      }
    }, _this.

    deleteContentFromStateByIndex = function (index, stateKey) {
      if (_this.state[stateKey].length) {var _this$setState3;
        var widget = document.querySelector('.' + styles.fileUpload);
        widget.classList.add(styles.noTransition);
        var newContent = [].concat(_this.state[stateKey]);var
        _id = newContent[index]._id;
        newContent.splice(index, 1);

        _this.setState((_this$setState3 = {}, _this$setState3[stateKey] = newContent, _this$setState3), function () {
          setTimeout(function () {
            widget.classList.remove(styles.noTransition);
            if (!_this.props.multiple) {
              return _this.props.updateContent(newContent, stateKey);
            }
            return _this.props.deleteContentItem(_id, stateKey);
          }, 0);
        });
      }
    }, _this.

    closeModalCropper = function () {return _this.setState({ isOpenModalCropper: false });}, _this.
    croppImg = function (status) {return _this.setState({ isCroppImg: status });}, _this.

    addDescription = function (description, index, file) {var _this$setState4;
      var stateKey = _this.getStateKey(file);
      var updatedContent = _this.state[stateKey].map(function (image) {return Object.assign({}, image);});
      updatedContent[index].description = description;

      _this.setState((_this$setState4 = {}, _this$setState4[
      stateKey] = updatedContent, _this$setState4),
      function () {
        _this.props.addDescription(updatedContent[index]._id, description, stateKey);
      });
    }, _this.

    handleClick = function (event) {var _this$state =
      _this.state,images = _this$state.images,videos = _this$state.videos;
      if ((images.length || videos.length) && event.target.tagName !== 'SPAN') {
        event.stopPropagation();
      }
    }, _this.

    rotateImage = function (evt, index, item) {
      evt.stopPropagation();

      var angle = UploadAssetWidget.getAngle(item);
      var relativeAngle = item.relativeAngle || 0;
      var newAngle = (+angle + 90) % 360;
      var newRelativeAngle = +relativeAngle + 90;

      var newImages = _this.state.images.map(function (image) {return Object.assign({}, image);});
      var currentImage = newImages[index];

      var imageNode = document.querySelector('#rotated_image_' + item._id);
      var imageNodeWrapperWidth = imageNode.offsetParent.offsetWidth;

      if (newRelativeAngle % 360 === 90 || newRelativeAngle % 360 === 270) {
        imageNode.style.height = imageNodeWrapperWidth + 'px';
      } else {
        imageNode.style.height = '';
      }

      if (currentImage.preview) {
        imageNode.dataset.relativeAngle = newRelativeAngle;
      }

      currentImage.angle = newAngle;
      currentImage.relativeAngle = newRelativeAngle;

      _this.setState({
        images: newImages },
      function () {
        if (_this.props.multiple) {
          return _this.props.rotateImage(currentImage._id, newAngle);
        }

        return _this.props.updateContent(newImages, 'images');
      });
    }, _this.

    sortImagesByOrder = function (order) {
      var orderedImages = order.map(function (index) {return _this.state.images[index];});
      _this.props.updateContent(orderedImages, 'images');
      return orderedImages;
    }, _this.

    renderSingleImage = function () {var _this$state2 =
      _this.state,images = _this$state2.images,nameImage = _this$state2.nameImage;

      if (!images || !images.length) {
        return null;
      }var

      image = images[0];

      return (
        _react2.default.createElement('div', { className: styles.previewWrapper },
          !image.preview && !image.uploadInProgress &&
          _react2.default.createElement(_PreviewSingleImage2.default, {
            isTabletDevice: _this.state.isTabletDevice,
            deleteFileTitle: _this.props.translate('rotate'),
            rotateImageTitle: _this.props.translate('delete'),
            deleteImage: function deleteImage(evt) {return _this.deleteContent(evt, 0, image);},
            rotateImage: function rotateImage(evt) {return _this.rotateImage(evt, 0, image);},
            index: 0,
            image: image.thumbnail ? image.thumbnail : image.preview,
            relativeAngle: image.relativeAngle || 0,
            uploadInProgress: !!image.preview,
            id: image._id,
            nameImage: nameImage }),


          (!!image.preview || !!image.uploadInProgress) &&
          _react2.default.createElement('div', { className: styles.uploadProgressWrapper },
            _react2.default.createElement('div', { className: styles.title }, _this.props.translate('loading')),
            _react2.default.createElement('div', { className: styles.uploadProgress },
              _react2.default.createElement('div', { id: 'uploadProgressBar_' + image._id })))));





    }, _this.

    renderPreviewList = function () {return (
        _react2.default.createElement(_PreviewList2.default, {
          items: _this.state.images,
          videos: _this.state.videos,
          deleteItem: _this.deleteContent,
          onChange: function onChange(order) {return _this.setState({ images: _this.sortImagesByOrder(order) });},
          uploadInProgress: _this.state.uploadInProgress,
          translate: _this.props.translate,
          isTabletDevice: _this.state.isTabletDevice,
          isMobile: _this.props.isMobile,
          addDescription: _this.addDescription,
          rotateImage: _this.rotateImage,
          multiple: _this.props.multiple }));}, _this.



    renderPlaceholder = function () {var _cx;
      var addMore = !_this.props.multiple && (_this.state.images.length || _this.state.videos.length) ?
      null :
      _react2.default.createElement('span', { className: (0, _classnames2.default)(styles.addMore, 'icon icon-clear') });
      var descriptionKey = 'selectImage' + (_this.props.isMobile ? 'Mobile' : '');

      var content = _this.props.multiple ?
      _react2.default.createElement('div', { className: styles.placeholderMessage }, addMore, _react2.default.createElement('span', null, _this.props.translate(descriptionKey))) :
      _react2.default.createElement('div', null, _react2.default.createElement('i', { className: 'icon icon-upload' }), _react2.default.createElement('span', null, _this.props.translate('selectImage')));

      var placeHolder =
      _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.imagePlaceholder, (_cx = {}, _cx[styles.multipleImagePlaceholder] = _this.props.multiple, _cx)) },
        _this.props.multiple &&
        _react2.default.createElement('div', { className: styles.placeholderIcons },
          _react2.default.createElement('span', { className: 'icon icon-gallery-image' }), '\xA0\xA0',

          !_this.props.withOutVideo && _react2.default.createElement('span', { className: 'icon icon-gallery-video-view' })),


        content);



      return _this.state.images.length || _this.state.videos.length ? addMore : placeHolder;
    }, _this.

    renderInfoSection = function (isEmpty) {var _cx2;
      if (!_this.props.multiple) {return null;}
      var translate = _this.props.rootTranslate('uploadWidget');

      return (
        _react2.default.createElement('span', { className: styles.infoSection },
          _react2.default.createElement('span', null, _this.state.images.length, '/', _this.state.contentLimit.images, '\xA0', translate('images')),
          !_this.props.withOutVideo &&
          _react2.default.createElement('span', null, _this.state.videos.length, '/', _this.state.contentLimit.videos, '\xA0', translate('videos')),
          _react2.default.createElement('span', {
              className: (0, _classnames2.default)(styles.deleteButton, (_cx2 = {}, _cx2[styles.disabled] = isEmpty || _this.state.uploadInProgress, _cx2)),
              onClick: !_this.state.uploadInProgress && _this.deleteAllContent },

            translate('deleteAll'))));



    }, _temp), _possibleConstructorReturn(_this, _ret);}UploadAssetWidget.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {if (!(0, _isEqual2.default)(nextProps.initialImages, this.props.initialImages)) {this.setState({ images: nextProps.initialImages });this.props.updateContent(nextProps.initialImages, 'images');}};UploadAssetWidget.prototype.

  render = function render() {var _this2 = this,_cx3,_cx4,_cx5;
    var isNotEmpty = !!(this.state.images.length || this.state.videos.length);
    var preview = this.props.multiple ? this.renderPreviewList : this.renderSingleImage;
    var withOutVideo = !this.props.withOutVideo ? ', video/*' : '';
    var raw = this.props.isRaw ? ', .pdf' : '';
    var mimeType = this.props.multiple ? 'image/*' + withOutVideo + raw : 'image/*';

    return (
      _react2.default.createElement('div', {
          ref: function ref(widget) {_this2.widget = widget;},
          className: (0, _classnames2.default)(
          styles.fileUpload, (_cx3 = {}, _cx3[
          styles.singleUpload] = !this.props.multiple, _cx3), (_cx4 = {}, _cx4[
          styles.invalid] = this.props.isInvalid, _cx4), (_cx5 = {}, _cx5[
          styles.uploadInProgress] = !!this.state.images.length && !this.props.multiple, _cx5),
          this.props.className),

          style: { cursor: isNotEmpty ? 'default' : 'pointer' } },

        _react2.default.createElement(_reactDropzone2.default, {
            onDrop: this.onContentDrop,
            multiple: this.props.multiple,
            accept: mimeType,
            style: { width: '100%' } },

          preview(),

          this.renderPlaceholder()),


        this.renderInfoSection(!isNotEmpty),

        this.props.multiple &&
        _react2.default.createElement('div', { className: styles.dragDropTitle }, this.props.translate('dragToAdd')),

        !this.props.multiple &&
        _react2.default.createElement('div', { className: styles.messageIcon },
          this.props.translate('iconSizeMessage')),


        this.props.withCropper &&
        _react2.default.createElement(_CropperModal2.default, {
          openModal: this.state.isOpenModalCropper,
          hideCropperModal: this.hideCropperModal,
          img: this.state.imgCropp,
          handleCropp: this.handleCropp,
          translate: this.props.translate })));




  };return UploadAssetWidget;}(_react.Component);UploadAssetWidget.convertLinkToImageObject = function () {var link = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';return { full: link, thumbnail: link };};UploadAssetWidget.formatInitialImages = function () {var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];return data.map(function (image) {var public_id = image.public_id,description = image.description,angle = image.angle,relativeAngle = image.relativeAngle,full = image.full,thumbnail = image.thumbnail,_id = image._id; // Initial angle calculation
    var imageAngle = UploadAssetWidget.getAngle({ angle: angle, full: full });var linkId = public_id || full && full.split('/').pop();return { thumbnail: thumbnail, full: full, link: linkId, description: description, angle: imageAngle, relativeAngle: relativeAngle || 0, contentType: _constants.cloudinaryContentTypes.IMAGE, _id: _id || 'upload_image_' + linkId };});};UploadAssetWidget.modifyImagesForPreview = function (images) {return images.map(function (image) {var modifiedImage = {};var baseUrl = (0, _constants.getAssetsBaseUrl)(_constants.cloudinaryContentTypes.IMAGE);if (image.full && (image.angle || image.angle === 0)) {var publicId = image.full.split('/').pop();modifiedImage.thumbnail = baseUrl + '/' + _constants.thumbnailModifier + ',a_' + image.angle + '/' + publicId;modifiedImage.full = baseUrl + '/' + _constants.fullModifier + ',a_' + image.angle + '/' + publicId;modifiedImage.description = image.description;} else {modifiedImage = Object.assign({}, image);}return modifiedImage;});};UploadAssetWidget.getAngle = function (image) {var angle = void 0;if (image.angle || image.angle === 0) {angle = image.angle;} else if (image.full) {var arrayFromImageLink = image.full.split('/');var imageParams = arrayFromImageLink[arrayFromImageLink.length - 2];var imageParamsArray = imageParams.split(',');var angleParam = imageParamsArray.filter(function (item) {return item.indexOf('a_') === 0;});angle = angleParam.length ? +angleParam[0].split('_').pop() : 0;} else {angle = 0;}return angle;};exports.default = UploadAssetWidget;

UploadAssetWidget.propTypes = {
  translate: _propTypes2.default.func,
  userToken: _propTypes2.default.string,
  rootTranslate: _propTypes2.default.func,
  withOutVideo: _propTypes2.default.bool,
  multiple: _propTypes2.default.bool,
  isMobile: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  initialImages: _propTypes2.default.array,
  initialVideos: _propTypes2.default.array,
  uploadInProgress: _propTypes2.default.func,
  uploadImageTimeout: _propTypes2.default.func,
  updateContent: _propTypes2.default.func,
  contentUploaded: _propTypes2.default.func,
  deleteContentItem: _propTypes2.default.func,
  markAssetToDelete: _propTypes2.default.func,
  suspendedUpload: _propTypes2.default.bool,
  rotateImage: _propTypes2.default.func,
  addDescription: _propTypes2.default.func,
  openMessageModal: _propTypes2.default.func,
  directUploadToCLoudinary: _propTypes2.default.bool,
  isInvalid: _propTypes2.default.bool,
  isRaw: _propTypes2.default.bool,
  withCropper: _propTypes2.default.bool,
  limitImages: _propTypes2.default.number };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/UploadAssetWidget/UploadAssetWidget.js
// module id = 2876
// module chunks = 0